import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toFlag } from './values';

export function directFlight(query: QueryObject): Pick<SearchCriteriaParams, 'directFlight'> | null {
  return toFlag(query.directFlight) ? { directFlight: true } : null;
}
